import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { MenuSide } from '../../components/MenuSide';
import { TableDados } from './components/TableDados';
import { Autocomplete, TextField } from "@mui/material";
import InputCustom from '../../components/InputCustom';
import { tokenUsuario, urlConsultaEmpresas } from '../../utils/constants';
import axios from 'axios';
import ButtonCustom from '../../components/ButtonCustom';

export default function Clientes() {

    const navigate = useNavigate();
    const [filtro, setFiltro] = useState('');
    const [clientes, setClientes] = useState([]);
    const [cliente, setCliente] = useState(null);

    const carregarClientes = async () => {
        try {
            const response = await axios.post(urlConsultaEmpresas, {
                token: tokenUsuario,
            })
            return response.data;
        } catch (error) {
            return null;
        }
    }

    const listarClientes = async () => {
        let clientesData = await carregarClientes();
        setClientes(clientesData);
    }

    useEffect(() => {
        listarClientes();
    }, []);

    return (
        <>
            <div className='row'>
                <div className='col-sm-2'>
                    <MenuSide />
                </div>
                <div className='col-sm-10' >
                    <br />
                    <div className='card' style={{ marginRight: '1%' }}>
                        <div className='card-header'>
                            <div className='row'>
                                <div className='col-sm-3' style={{ fontWeight: 700, fontSize: '25px', }}>
                                    Clientes
                                </div>
                                <div className='col-sm-7'></div>
                                <div className='col-sm-2 text-end'>
                                    <ButtonCustom
                                        onClick={() => {
                                            navigate({
                                                pathname: "/clientes/adicionar",
                                            });
                                        }}
                                        color={"error"}
                                        texto={"Adicionar"}
                                        icon={null}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-sm-3'>
                                    <h6>Nome do item</h6>
                                    <InputCustom
                                        value={filtro}
                                        setValue={(event) => {
                                            event.preventDefault();
                                            setFiltro(event.target.value)
                                        }}
                                        type={'text'}
                                        placeHolder={'Nome do item'}

                                    />
                                </div>
                                <div className='col-sm-3'>
                                    <h6>Empresa</h6>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={clientes}
                                        getOptionLabel={(option) => `${option.nome}`}
                                        value={cliente}
                                        onChange={(event, newValue) => {
                                            setCliente(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                sx={{
                                                    '& .MuiInputBase-input': {

                                                    },
                                                    '& .MuiInputBase-root': {
                                                        height: "39px",
                                                        borderRadius: '0.5rem',
                                                    },
                                                    '& .MuiOutlinedInput-root': {
                                                        height: "39px",
                                                        padding: '10px',
                                                    },
                                                    width: '100%',
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <br />
                            <TableDados nome={filtro} empresa={cliente} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
